import { type FC } from 'react';
import { Button, Paper, Stack, Text } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';

interface CascadeTemplateDangerZoneProps {
    isPending: boolean;
    onDelete: () => void;
}

export const CascadeTemplateDangerZone: FC<CascadeTemplateDangerZoneProps> = ({ isPending, onDelete }) => {
    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap='sm'>
                <Text
                    fw={600}
                    size='sm'
                >
                    Действия
                </Text>

                <Button
                    color='red'
                    variant='light'
                    leftSection={<IconTrash size={16} />}
                    onClick={onDelete}
                    disabled={isPending}
                    loading={isPending}
                >
                    Удалить шаблон
                </Button>
            </Stack>
        </Paper>
    );
};
